export enum CardRarityEnum {
  Common = 'common',
  Rare = 'rare',
  Epic = 'epic',
  Legendary = 'legendary',
  Relic = 'relic'
}

export enum CardTypeEnum {
  Token = 'token',
  TokenCharacter = 'character',
  Influencer = 'influencer'
}

export enum PackageTypeEnum {
  giveaway,
  subscription
}
